import { z } from 'zod';

/**
 * Boolean carried in a query string.
 *
 * `z.coerce.boolean()` is plain JS truthiness, so the string `"false"`
 * is non-empty and coerces to `true` — `?hasParcel=false` silently
 * behaved exactly like `?hasParcel=true`, and the "without polygon"
 * filter could never return anything. Parse the wire spelling instead.
 */
export const booleanParam = z.union([
  z.boolean(),
  z.enum(['true', '1', 'yes', 'on']).transform(() => true),
  z.enum(['false', '0', 'no', 'off', '']).transform(() => false),
]);

export const PaginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(200).default(50),
  sort: z.string().optional(),
  order: z.enum(['asc', 'desc']).optional(),
});
export type PaginationQuery = z.infer<typeof PaginationQuerySchema>;

export const PaginationMetaSchema = z.object({
  page: z.number().int(),
  limit: z.number().int(),
  total: z.number().int(),
  totalPages: z.number().int(),
});
export type PaginationMeta = z.infer<typeof PaginationMetaSchema>;

export const paginated = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    pagination: PaginationMetaSchema,
  });
